import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavItem from "./NavItem";
import { menuList } from "../menuList";
import { Drawer, Typography, useTheme } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const SidebarNav = ({ onClose, open, variant }) => {
  const theme = useTheme();


  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: 280,
          backgroundColor: "black",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          padding: 1,
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
            width={1}
            paddingX={2}
            paddingY={1}
          >
            <Typography
              textAlign={"center"}
              component="a"
              sx={{ mr: 0.5 }}
              href={"/"}
            >
              <img src="/logo.png" alt="logo" width={150} />
            </Typography>
          </Box>
          <Box paddingX={2} paddingY={2}>
            {menuList.map((page) =>
              page.items ? (
                <Box sx={{ ml: 1, fontSize: 15 }}>
                  <NavItem title={page.name} items={page.items} />
                </Box>
              ) : (
                <Button
                  component="a"
                  href={'/'}
                  sx={{
                    display: "block",
                    color: "white",
                    fontSize: 13,
                    "&:hover": {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  {page.name}
                </Button>
              )
            )}

            <Box sx={{ my: 2 }}>
              <Button
                startIcon={<WhatsAppIcon />}
                component="a"
                href="https://wa.me/qr/O6U6CP3K6KMDP1"
                size="small"
                target="_blank"
                variant="contained"
                sx={{ px: 4 }}
                fullWidth
              >
                Nous contacter
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

SidebarNav.propTypes = {
  pages: PropTypes.object.isRequired,
};

export default SidebarNav;
